// extracted by mini-css-extract-plugin
export var reviews = "iframe-module--reviews--0e00e";